export const createISOWithTimezone = (
    year: number,
    month: number,
    day: number,
    hour: number,
    minute: number,
    second: number,
    timezone: string
): string => {
    // Build the naive UTC candidate for this wall-clock time
    const utcCandidate = Date.UTC(year, month - 1, day, hour, minute, second)

    // Use Intl to find what offset (in minutes) applies in the target timezone
    const fmt = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        timeZoneName: 'shortOffset',
        hour12: false,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    })

    const parts = fmt.formatToParts(new Date(utcCandidate))
    const tzName = parts.find((p) => p.type === 'timeZoneName')?.value || 'UTC'

    // tzName is like "GMT+1" or "GMT-4"
    const match = tzName.match(/GMT([+-]\d{1,2})(?::(\d{2}))?/)
    let offsetMinutes = 0
    if (match) {
        const hours = parseInt(match[1], 10)
        const mins = match[2] ? parseInt(match[2], 10) : 0
        offsetMinutes = hours * 60 + (hours < 0 ? -mins : mins)
    }

    // Subtract offset (because e.g. "noon in London" = "11:00 UTC" if offset = +60)
    const utcMillis = Date.UTC(year, month - 1, day, hour, minute, second) - offsetMinutes * 60_000

    return new Date(utcMillis).toISOString()
}
